import { combineReducers, Action } from 'redux';
import overlayReducer from './overlay/reducer';
import { connectRouter } from 'connected-react-router';
import { createHashHistory } from 'history';
import themesReducer from './themes/reducer';
import navigationReducer from './navigation/reducer';
import userReducer from './user/reducer';
import serviceReducer from './services/reducer';
const asyncInitialState = require('redux-async-initial-state');

// Initial State
export const initialState: AppState = {} as AppState;
export const history = createHashHistory();

// Reducers (AppState)
const appReducer = combineReducers({
    overlay: overlayReducer,
    themes: themesReducer,
    navigation: navigationReducer,
    user: userReducer,
    services: serviceReducer,
    router: connectRouter(history),
    asyncInitialState: asyncInitialState.innerReducer
});
const asyncReducer = asyncInitialState.outerReducer(appReducer);

export type AppState = ReturnType<typeof appReducer>;

// Bootstrap Reducer
const rootReducer = (state: AppState = initialState, action: Action): AppState => 
{
    if(action.type === "@@INIT")
    {
        state = initialState;
    }

    return asyncReducer(state, action);
}

export default rootReducer;